export default {
    dashboard: {
        totalWordsGenerated: 'Total de palabras generadas',
        wordsPerDay: 'Palabras/día',
        content: 'Contenido',
        date: 'Fecha',
        variationCount: 'Recuento de variantes',
        transactionId: 'ID de Transacción',
        totalWordsCount: 'Recuento del total de palabras',
        action: 'Acción',
        goTo: 'Ir a',
        viewMore: 'Ver más',
        showLess: 'Mostrar menos',
        tabImage: 'Image',
        tabText: 'Text',
        dashboardSubtitle: 'Manage your AI generated content',
    },
};
